let sidebar;
let element;
let desktopMedia;

let lastScrollTop = 0;
let windowHeight = 0;
let sidebarHeight = 0;

const gap = 20;
const gapText = `${gap}px`;

function enableAbsoluteCalculatedPosition(top) {
  element.style.top = top;
  element.style.bottom = 'auto';

  element.classList.remove('sticky');
  element.classList.remove('fixed');
  element.classList.add('absolute');
  element.classList.remove('static');
}
function enableAbsoluteBottomPosition() {
  element.classList.remove('sticky');
  element.classList.remove('fixed');
  element.classList.add('absolute');
  element.classList.remove('static');
  element.style.top = 'auto';
  element.style.bottom = gapText;
}
function enableFixedTopPosition() {
  element.classList.remove('sticky');
  element.classList.add('fixed');
  element.classList.remove('absolute');
  element.classList.remove('static');
  element.style.top = gapText;
  element.style.bottom = 'auto';
}
function enableFixedBottomPosition() {
  element.classList.remove('sticky');
  element.classList.add('fixed');
  element.classList.remove('absolute');
  element.classList.remove('static');
  element.style.top = 'auto';
  element.style.bottom = gapText;
}
function enableStaticPosition() {
  element.classList.remove('sticky');
  element.classList.remove('fixed');
  element.classList.remove('absolute');
  element.classList.add('static');
  element.style.top = 'auto';
  element.style.bottom = 'auto';
}

function enableStickyPosition() {
  element.classList.add('sticky');
  element.classList.remove('fixed');
  element.classList.remove('static');
  element.classList.remove('absolute');
  element.style.top = gapText;
  element.style.bottom = 'auto';
}

function onScroll() {
  if (!desktopMedia.matches) {
    return;
  }

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const isScrollUp = scrollTop < lastScrollTop;
  const bottomViewportEdge = scrollTop + windowHeight;
  const elementOffsetTop = element.offsetTop;
  const sidebarOffsetTop = sidebar.offsetTop;
  const elementHeight = element.scrollHeight;

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  if (elementHeight + gap < windowHeight) {
    // elementHeight is smaller than viewport height
    enableStickyPosition();
    return;
  }
  // elementHeight is bigger than viewport height

  if (bottomViewportEdge > sidebarOffsetTop + sidebarHeight) {
    // we are next to footer, fix the element to bottom of the sidebar (absolute position)
    enableAbsoluteBottomPosition();
    return;
  }

  if (bottomViewportEdge < sidebarOffsetTop + elementHeight) {
    //  we are above element offsetTop, we need to use static position
    if (element.classList.contains('fixed')) {
      if (scrollTop < sidebarOffsetTop - gap) {
        enableStaticPosition();
      }
    } else {
      // we are on the top of the page (top part of element is visible)
      enableStaticPosition();
    }
    return;
  }

  // we are in the middle, fix the element to bottom of the screen (fixed position) or use absolute position
  if (!isScrollUp) {
    // scrolling down
    if (element.classList.contains('fixed') && element.style.bottom === 'auto') {
      // fix the element to the sidebar by absolute position
      enableAbsoluteCalculatedPosition(`${elementOffsetTop + scrollTop - sidebarOffsetTop}px`);
    } else if (window.scrollY + windowHeight > sidebarOffsetTop + element.scrollHeight + elementOffsetTop + gap) {
      enableFixedBottomPosition();
    } else if (element.classList.contains('sticky')) {
      enableFixedTopPosition();
    }

    return;
  }

  // scrolling up
  if (!element.classList.contains('absolute') && element.style.top !== gapText) {
    // fix the element to the sidebar by absolute position
    enableAbsoluteCalculatedPosition(`${elementOffsetTop + scrollTop - sidebarOffsetTop}px`);
  } else if (scrollTop < elementOffsetTop + sidebarOffsetTop - gap) {
    enableFixedTopPosition();
  }
}
function updateVariables() {
  windowHeight = window.innerHeight;
  sidebarHeight = sidebar.scrollHeight;
}
export default function init() {
  sidebar = document.getElementById('col-sidebar');
  element = document.getElementById('desktop-enquiry-form');
  desktopMedia = window.matchMedia('(min-width: 1280px)');

  updateVariables();

  window.addEventListener('resize', updateVariables);
  document.addEventListener('scroll', onScroll, { passive: true });
}
